"use strict";

var _interopRequireDefault = require("/app/node_modules/@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Store = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("/app/node_modules/@babel/runtime/helpers/esm/createClass"));

var _vue = require("vue");

// eslint-disable-next-line @typescript-eslint/ban-types
var Store = /*#__PURE__*/function () {
  function Store() {
    (0, _classCallCheck2.default)(this, Store);
    var data = this.data();
    this.setup(data);
    this.state = (0, _vue.reactive)(data);
  }

  (0, _createClass2.default)(Store, [{
    key: "setup",
    value: // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-empty-function
    function setup(data) {}
  }, {
    key: "setState",
    value: function setState(state) {
      this.state = (0, _vue.reactive)(state);
    }
  }, {
    key: "getState",
    value: function getState() {
      return (0, _vue.readonly)(this.state);
    }
  }]);
  return Store;
}();

exports.Store = Store;